import styled from 'styled-components';

export const Container = styled.div`
  background-color: #c5eaff;
  padding: 95px 0;
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
`;

// Styled Components
export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 50px;
  overflow-x: auto;

  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  img {
    width: 35%;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    overflow-x: auto;
    scroll-behavior: smooth;
  }
`;

///

export const ContainerSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;

  p {
    font-family: 'Inter', sans-serif;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    img {
      width: 100%;
    }
  }
`;

export const ContainerSections = styled.div`
  display: flex;
  gap: 20px;

  overflow-x: auto;
  @-moz-document url-prefix() {
    scrollbar-width: none;
  }
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  > div {
    flex: 0 0 auto;
    width: 230px;
    img {
      width: 30%;
    }

    @media (max-width: 768px) {
      img {
        width: 70%;
      }
    }
  }
`;

export const NormalText = styled.p`
  font-weight: 400;
  font-size: 18px;
  color: #0015c1;
`;
export const BigText = styled.p`
  font-weight: 400;
  font-size: 40px;
  color: #0015c1;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;
